import { api } from './client'
import type { components } from './generated/schema'

// Bán lẻ › Video hướng dẫn sử dụng: danh sách có thứ tự trỏ tới video (và ảnh
// bìa) trong Thư viện ảnh. Người xem chỉ thấy video đang hiện; người sửa
// (shop_content.write) đọc /manage để thấy cả video đang ẩn.

export type ShopGuideVideo = components['schemas']['ShopGuideVideo']
export type ShopGuideVideoInput = components['schemas']['ShopGuideVideoInput']

const BASE = '/shop-admin/guide-videos'

export const shopGuideVideosApi = {
    list: () => api.get<ShopGuideVideo[]>(BASE),
    manage: () => api.get<ShopGuideVideo[]>(`${BASE}/manage`),
    create: (input: ShopGuideVideoInput) =>
        api.post<ShopGuideVideo>(BASE, input),
    update: (id: string, input: ShopGuideVideoInput) =>
        api.put<ShopGuideVideo>(`${BASE}/${id}`, input),
    remove: (id: string) => api.delete<void>(`${BASE}/${id}`),
    reorder: (ids: string[]) =>
        api.put<ShopGuideVideo[]>(`${BASE}/order`, { ids }),
}

/** Ô gửi lên server từ một video đang có (bật / tắt hiện giữ nguyên ô khác). */
export function toGuideVideoInput(v: ShopGuideVideo): ShopGuideVideoInput {
    return {
        title: v.title,
        description: v.description,
        group_name: v.group_name,
        video_media_id: v.video_media_id,
        poster_media_id: v.poster_media_id,
        duration_seconds: v.duration_seconds,
        active: v.active,
    }
}
